import React, { useEffect, useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import SceneBackground from './SceneBackground'

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        gap: 16,
        padding: '12px 20px 20px',
        overflow: 'auto',
        '@media (min-width: 600px) and (orientation: landscape)': {
            gap: 10,
            padding: '8px 16px 16px',
        },
        '@media (max-width: 599px)': {
            padding: '4px 10px 12px',
            gap: 10,
        },
    },
    sceneContainer: {
        width: '100%',
        maxWidth: 520,
        flexShrink: 0,
        minHeight: 100,
        borderRadius: 16,
        '@media (min-width: 600px) and (orientation: landscape)': {
            maxWidth: 'min(520px, 45vh)',
        },
        '@media (max-width: 599px)': {
            borderRadius: 10,
        },
    },
}))

const RandomBranchNode = ({ node, previousNode, imageMap, onNodeComplete }) => {
    const classes = useStyles()

    const options = node.options || []

    const randomIndex = useMemo(
        () => Math.floor(Math.random() * options.length),
        [options.length]
    )

    const animationDuration = node.scenarioMentors?.[0]?.animationLengthInSeconds || 1.5

    useEffect(() => {
        if (options.length === 0) return

        const delay = Math.max(animationDuration * 1000, 1000)
        const timer = setTimeout(() => {
            onNodeComplete({
                nodeId: node.nodeId,
                chosenAlternativeIndex: randomIndex,
            })
        }, delay)

        return () => clearTimeout(timer)
    }, [])

    return (
        <div className={classes.container}>
            <div className={classes.sceneContainer}>
                <SceneBackground
                    node={node}
                    previousNode={previousNode}
                    imageMap={imageMap}
                    duration={animationDuration}
                />
            </div>
        </div>
    )
}

export default RandomBranchNode
